import { Injectable, Optional, Inject } from '@angular/core';
import { GenericTranslationService } from '../../services/generic-translation.service';
import {
  ComponentConfig,
  createComponentConfigToken,
  createConfigProvider,
} from '../../services/translation-config.helper';
import { GenericItemListTranslations, GenericItemListTranslationInput } from './generic-item-list-translations.interface';
import { DEFAULT_GENERIC_ITEM_LIST_TRANSLATIONS } from './generic-item-list-translations.defaults';
import { GERMAN_GENERIC_ITEM_LIST_TRANSLATIONS } from './generic-item-list-translations.de';

export interface GenericItemListConfig extends ComponentConfig<GenericItemListTranslations> {}

export const GENERIC_ITEM_LIST_CONFIG = createComponentConfigToken<GenericItemListTranslations>('GENERIC_ITEM_LIST_CONFIG');

@Injectable({
  providedIn: 'root',
})
export class GenericItemListTranslationService extends GenericTranslationService<GenericItemListTranslations> {
  constructor(@Optional() @Inject(GENERIC_ITEM_LIST_CONFIG) config?: GenericItemListConfig) {
    super(DEFAULT_GENERIC_ITEM_LIST_TRANSLATIONS);

    this.registerLanguage('de', GERMAN_GENERIC_ITEM_LIST_TRANSLATIONS);

    if (config?.translations) {
      this.setGlobalTranslations(config.translations);
    }
  }
}

export const GenericItemListConfigProvider = createConfigProvider<GenericItemListTranslations>(GENERIC_ITEM_LIST_CONFIG);
